import React from 'react';
import { ChipDataItem } from '../../types';
import './chip-filter.scss';

interface ChipFilterItemProps extends ChipDataItem {
  onPress: () => void;
}

export const ChipFilterItem: React.FC<ChipFilterItemProps> = ({
  selected,
  onPress,
  value,
  type,
}) => {
  return (
    <button
      type="button"
      className={`filter-item${selected ? ' selected' : ''}`}
      onClick={onPress}
      disabled={type === 'text'}
    >
      <span className="font-medium">{value}</span>
    </button>
  );
};
